export default __webpack_public_path__ + "static/media/author.9f3d4662.jpg";